import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { } from '@lockerpm/design';

import commonComponents from "../../../components/common";
import itemsComponents from "../../../components/items";

import Filter from "./components/access-log/Filter";
import TableData from "./components/access-log/TableData";
import BoxData from "./components/access-log/BoxData";

import global from "../../../config/global";
import projectServices from "../../../services/project";
import resourceServices from "../../../services/resource";
import { getRouterByLocation, scrollEnd } from '../../../utils/common';

const ProjectAccessLog = (props) => {
  const { } = props;
  const { t } = useTranslation();
  const { PageHeader } = commonComponents;
  const { NoData, Pagination } = itemsComponents;

  const isMobile = useSelector((state) => state.system.isMobile)
  const locale = useSelector((state) => state.system.locale)

  const currentPage = getRouterByLocation(window.location);
  const projectId = currentPage?.params?.project_id;

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [accessLogClients, setAccessLogClients] = useState([]);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({
    page: 1,
    size: global.constants.PAGE_SIZE,
  });

  useEffect(() => {
    getAllTotal()
    fetchAccessLogClients()
  }, [])

  useEffect(() => {
    fetchData()
  }, [projectId, JSON.stringify(params)])
  
  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      size: global.constants.PAGE_SIZE
    })
  }, [isMobile])

  const handleChangePage = (page, size) => {
    setParams({
      ...params,
      page,
      size
    })
  };

  const fetchAccessLogClients = () => {
    resourceServices.list_access_log_clients().then((response) => {
      setAccessLogClients(response);
    }).catch(() => {
      setAccessLogClients([])
    })
  }

  const getAllTotal = async () => {
    await projectServices.access_logs(projectId, {page: 1, size: 1}).then((response) => {
      setAllTotal(response.count)
    }).catch(() => {
      setAllTotal(0)
    })
  }

  const fetchData = () => {
    setLoading(true)
    projectServices.access_logs(projectId, params).then((response) => {
      setData(response.results);
      setTotal(response.count)
      setLoading(false)
    }).catch(() => {
      setData([])
      setTotal(0)
      setLoading(false)
    })
  }

  return (
    <div
      className="access-log layout-content"
      onScroll={(e) => scrollEnd(e, params, total, setParams)}
    >
      <PageHeader
        title={t('access_log.title')}
        subtitle={t('access_log.description')}
        docLabel={t('access_log.doc')}
        docLink={global.urls.DOC_LINKS[locale].PROJECT_ACCESS_LOGS}
        actions={[]}
      />
      {
        allTotal > 0 && <Filter
          className={'mt-6'}
          params={params}
          accessLogClients={accessLogClients}
          setParams={(v) => setParams({ ...v, page: 1 })}
        />
      }
      {
        total == 0 && <NoData
          loading={loading}
          className={'mt-6'}
        />
      }
      {
        total > 0 && <>
          {
            isMobile ? <BoxData
              className="mt-4"
              loading={loading}
              data={data}
              params={params}
              accessLogClients={accessLogClients}
            /> : <TableData
              className="mt-4"
              loading={loading}
              data={data}
              params={params}
              accessLogClients={accessLogClients}
            />
          }
        </>
      }
      {
        total > global.constants.PAGE_SIZE && !isMobile && <Pagination
          params={params}
          total={total}
          onChange={handleChangePage}
        />
      }
    </div>
  );
}

export default ProjectAccessLog;